module.exports = __webpack_public_path__ + "img/заявки.50c2c1a0.svg";